import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { updateOrderStatus } from "../../api/apiOrders";
import parseError from "../../utils/parseError";

export const useUpdateOrderStatus = () => {
    const queryClient = useQueryClient();

    const { mutate: updateOrderStatusMutate, isPending: isUpdatingStatus } = useMutation({
        mutationFn: ({ id, data }) => updateOrderStatus(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Order status updated");
            queryClient.invalidateQueries(["orders"]);
            queryClient.invalidateQueries(["order"]);
            queryClient.invalidateQueries(["order-timeline"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to update status");
        },
    });

    return { updateOrderStatusMutate, isUpdatingStatus };
};
